/**
 * It waits for milliseconds and returns.
 *
 * You should probably not use this.
 *
 * Think about alternative means of solving your problem before reaching for this.
 */
export async function sleep(milliseconds: number) {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
}
